function Footer() {
    return (<div className="footer" >
        <p className="copyRight">&copy; Copyright 2023 <strong><span>Love2Programming</span></strong>. All Rights Reserved</p>
        <a href="#" className="top" title="Go To Top">&#8593;</a>
    </div> );
}

export default Footer;